import React, { useEffect, useState } from 'react';
import { isValidEmail } from '@seedlang/utils';
import Alert from 'components/alert';
import emailTypoSuggestion from 'utils/email_typo_suggestion';

const EmailTypoWarning = ({ email, focused }) => {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => setDismissed(false), [email]);
  const suggestion = isValidEmail(email) && emailTypoSuggestion(email);
  if (!suggestion || focused || dismissed) { return null; }

  return (
    <Alert role='status' showCloseButton onClose={() => setDismissed(true)} padding='10px 25px 10px 10px'>
      Did you mean <strong>{suggestion}</strong>? Please double-check your email address.
    </Alert>
  );
};

export default EmailTypoWarning;
